import React, { useState } from "react";
import {
  FacebookShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from "react-share";
import styles from "./index.module.css";
import facebook from "../../assets/Group 6.svg";
import instagram from "../../assets/Instagram.png";
import twitter from "../../assets/rf_twitter.png";
import whatsapp from "../../assets/rf_whatsapp.png";
import { toast } from "react-toastify";
import copy_invite from "../../assets/copy_invite.png";

const ShareReferral = ({ referralCode }) => {
  const [copied, setCopied] = useState(false);

  const referralUrl = `https://book-a-demo.codeyoung.com/#/?utm_source=Referral_studentPortal&utm_medium=referral&referal=${referralCode}`;
  const shareMessage =
    "Hey I am inviting you to register for Live online Coding classes for K-12 kids by Codeyoung. Use this link to register through referral and win special goodies and discounts!";

  const handleShareClick = (type) => {
    if (!referralCode) {
      toast.error("Referral code not found, please contact support");
      return;
    }
    toast.success("Referral link copied to clipboard");
    navigator.clipboard.writeText(referralUrl);
    if (type === "insta") {
      setTimeout(() => {
        window.open("https://www.instagram.com/", "_blank");
      }, 1000);
    }
  };

  const handleCopy = () => {
    if (!referralCode) {
      toast.error("Referral code not found, please contact support");
      return;
    }
    navigator.clipboard.writeText(referralUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 3000);
  };

  return (
    <div className={styles.container}>
      <div className={styles.copyInviteButton} onClick={handleCopy}>
        {
          copied ? <p className={styles.copyInviteText}>Copied!</p> : 
          <>
            <p className={styles.copyInviteText}>Copy invite link</p>
            <img src={copy_invite} className={styles.copyInviteIcon} alt="copy" />
          </>
        }
      </div>
      <div className={styles.shareHeaderContainer}>
        <p className={styles.shareTitle}>Share invite link via</p>
        <div className={styles.socialIcons}>
          <FacebookShareButton
            url={referralUrl}
            quote={shareMessage}
            onClick={handleShareClick}
            className={styles.shareButton}
          >
            <img src={facebook} alt="Facebook" className={styles.icon} />
          </FacebookShareButton>

          <button
            className={styles.shareButton}
            onClick={() => handleShareClick("insta")}
          >
            <img src={instagram} alt="Instagram" className={styles.icon} />
          </button>

          <TwitterShareButton
            url={referralUrl}
            title={shareMessage}
            onClick={handleShareClick}
            className={styles.shareButton}
          >
            <img src={twitter} alt="X" className={styles.icon} />
          </TwitterShareButton>

          <WhatsappShareButton
            url={referralUrl}
            title={shareMessage}
            onClick={handleShareClick}
            className={styles.shareButton}
          >
            <img src={whatsapp} alt="WhatsApp" className={styles.icon} />
          </WhatsappShareButton>

        </div>
      </div>
    </div>
  );
};

export default ShareReferral;
